import {IOptInModalInfo} from "./optin-modal-info.interface";


export class OptInModalInfo implements IOptInModalInfo{
  constructor(iOptInModalInfo ?: IOptInModalInfo ) {
    this.optInModalText =  iOptInModalInfo?.optInModalText || '';
    this.optInModalTitle =  iOptInModalInfo?.optInModalTitle || '';
    this.continueButtonText =  iOptInModalInfo?.continueButtonText || 'Continue';
  }
  optInModalText: string;
  optInModalTitle: string;
  continueButtonText: string;

}
